import { Pipe, PipeTransform } from '@angular/core';

export interface Address {
  address1?: string;
  city?: string;
  state?: string;
  zip?: string;
}

@Pipe({
  name: 'addressHtmlFormatter',
  standalone: true,
})
export class AddressHtmlFormatterPipe implements PipeTransform {
  transform({ address1 = '', city = '', state = '', zip = '' }): string {
    const addressCityStateString = `${city}, ${state} ${zip}`;

    // If address1 and city are not available - assume we have an empty address so show a hyphen.
    return address1 && city
      ? `<span title="${address1}\n${addressCityStateString}">${address1} <br /> ${addressCityStateString}</span>`
      : '&#8212;';
  }
}
